/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Email_PlaceholderInputs */

const en_feedback_email_placeholder = /** @type {(inputs: Feedback_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@company.com`)
};

const zh_hans1_feedback_email_placeholder = /** @type {(inputs: Feedback_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@company.com`)
};

const pt_br2_feedback_email_placeholder = /** @type {(inputs: Feedback_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`voce@empresa.com`)
};

const es_feedback_email_placeholder = /** @type {(inputs: Feedback_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu@empresa.com`)
};

const fr_feedback_email_placeholder = /** @type {(inputs: Feedback_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vous@entreprise.com`)
};

const de_feedback_email_placeholder = /** @type {(inputs: Feedback_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`du@firma.de`)
};

const ru_feedback_email_placeholder = /** @type {(inputs: Feedback_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@company.com`)
};

const it_feedback_email_placeholder = /** @type {(inputs: Feedback_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu@azienda.com`)
};

/**
* | output |
* | --- |
* | "you@company.com" |
*
* @param {Feedback_Email_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_email_placeholder = /** @type {((inputs?: Feedback_Email_PlaceholderInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Email_PlaceholderInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_feedback_email_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_feedback_email_placeholder(inputs)
	if (locale === "es") return es_feedback_email_placeholder(inputs)
	if (locale === "fr") return fr_feedback_email_placeholder(inputs)
	if (locale === "de") return de_feedback_email_placeholder(inputs)
	if (locale === "ru") return ru_feedback_email_placeholder(inputs)
	if (locale === "it") return it_feedback_email_placeholder(inputs)
	return en_feedback_email_placeholder(inputs)
});